module.exports = "<div class=\"ubg-tab-dialog-dialog ubg-color-surface\" [ngClass]=\"getDialogClass()\">\n  <ng-content></ng-content>\n</div>"